import { Component, Input, ElementRef, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NmInput } from '../input/input';

@Component({
  selector: 'nm-textarea',
  providers: [
    {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NmTextarea),
    multi: true,
    }
  ],
  template: `
    <textarea
      class="form-control"
      [placeholder]="placeholder"
      [(ngModel)]="_value"
      [readonly]="readonly"
      (change)="onInputChange()"
      (blur)="onInputTouched()"
    ></textarea>
  `
})
export class NmTextarea extends NmInput {

}


// WEBPACK FOOTER //
// ./src/widgets/textarea/textarea.ts